const STOP_DICTATE = 'WEB_CHAT/STOP_DICTATE';

export default function stopDictate() {
  return { type: STOP_DICTATE };
}

export { STOP_DICTATE };
